import React, { Component } from "react";
import "./footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faInstagram } from "@fortawesome/free-brands-svg-icons";

export default class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <div className="container-f">
          <div className="row part-row">
            <div className="d-inline part-0 part1 col-md-2">
              <h3 className="f-title align">About</h3>
              <p className="text-f align">Handcrafted with React and CSS.</p>
              <p className="align text-f">© AhmetAksu 2021</p>
            </div>
            <div className="d-inline part-0 col-md-2 part2">
              <h3 className="f-title align">Explore</h3>
              <a href="#home" className="align text-f2 link2">Home</a>
              <a href="#about" className="align text-f2 link2">About</a>
              <a href="#exp" className="align text-f2 link2">Experiences</a>
              <a href="#courses" className="align text-f2 link2">Taken Courses</a>
            </div>
            <div className="d-inline part-0 col-md-2 part3">
              <h3 className="f-title align">Follow</h3>
              <div className="align">
                <a className="align text-f" href="https://www.instagram.com/ahmetaksu001/" target="_blank" rel="noreferrer">
                  <FontAwesomeIcon
                    icon={faInstagram}
                    size="3x"
                    className="html_icon mr-2 medias align"
                    target="_blank"
                  />
                </a>
                <a className="align text-f" href="https://github.com/AhmetAksu375"
                    target="_blank"
                    rel="noreferrer">
                  <FontAwesomeIcon
                    icon={faGithub}
                    size="3x"
                    className="html_icon mr-2 medias"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
